// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';

export const DigitalUserAccountSearch = t.struct({
    isEnabled: t.Boolean,
    showByDefault: t.Boolean
}, {
    defaultProps: {
        isEnabled: false,
        showByDefault: false
    },
    name: 'DigitalUserAccountSearchFeature',
    strict: true
});
